<template>
    <ContentComponent :showSemaforo="false">
        <template #principal>
            <div class="row p-5">
                <p class="col-12 subtitulos text-center">NUEVA SEDE</p>
                <hr>
                <p class="col-12 subtitulos">Ubicación</p>
                <div class="col-4">
                    <label for="departamento_id">Departamento</label>
                    <b-form-select 
                        :options="departamentos" 
                        v-model="sede.departamento_id"
                        id="departamento_id"
                        value-field="id"
                        text-field="nombre_dpto"
                        @input="getMunicipios"
                    ></b-form-select>
                    <span class="text-danger" v-if="errores">{{ errores.departamento_id }}</span>
                </div>
                <div class="col-4">
                    <label for="municipio_id">Municipio</label>
                    <b-form-select 
                        :options="municipios" 
                        v-model="sede.municipio_id"
                        id="municipio_id"
                        value-field="id"
                        text-field="mcpio"
                    ></b-form-select>
                    <span class="text-danger" v-if="errores">{{ errores.municipio_id }}</span>
                </div>
                <div class="col-4">
                    <label for="nombre">Nombre sede</label>
                    <b-form-input
                        id="nombre" 
                        v-model="sede.nombre"
                    ></b-form-input>
                    <span class="text-danger" v-if="errores">{{ errores.nombre }}</span>
                </div>
                <div class="col-6 my-3">
                    <!-- <button class="btn btn-primary" ">Guardar</button> -->
                    <a-button type="primary" @click="guardarSede">Guardar</a-button>
                </div>
                <div class="col-12 my-3">
                    <b-alert v-if="message" variant="success" show>{{ message }}</b-alert>
                </div>
            </div>
        </template>
    </ContentComponent>
</template>
<script>
    import ContentComponent from '@/components/Content/Index.vue';
    import axios from 'axios';
    export default {
        components: {
            ContentComponent
        },
        data() {
            return {
                departamentos: [],
                errores: null,
                municipios: [],
                sede: {departamento_id: null, municipio_id: null, nombre: null, user_id: null},
                message: null
            }
        },
        mounted() {
            this.getDepartamentos();
            this.sede.user_id = this.$store.state.user.id;
        },
        methods: {
            getDepartamentos(){
                axios.get('/api/departamentos', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.departamentos = res.data.departamentos;
                })
            },
            getMunicipios(){
                axios.get(`/api/municipios/${this.sede.departamento_id}`, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.municipios = res.data.municipios;
                })
            },
            guardarSede(){
                
                axios.post('/api/sedes', this.sede, {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    console.log(res.data)
                    if(res.data.status === 'errorValidation'){
                        this.errores = res.data.error
                    }
                    if(res.data.status === 'success'){
                        this.message = res.data.message
                        this.sede.departamento_id = null
                        this.sede.municipio_id = null
                        this.sede.nombre = null
                    }
                })
                .catch(err => console.log(err))
            }
        },
    }
</script>